import { createSelector } from 'reselect';

import { StateDictionary } from '../reducers/utils/state-manager';

export type EmployeeDirectoryImportState = {
  employeeDirectoryImportsById: { [employeeDirectoryImportId: number]: EmployeeDirectoryImport };
  employeeDirectoryImportsStateByOrgId: StateDictionary;
};
type State = { employeeDirectoryImports: EmployeeDirectoryImportState };

const employeeDirectoryImportsByIdSelector = (state: State) =>
  state.employeeDirectoryImports.employeeDirectoryImportsById;
const employeeDirectoryImportsSelector = createSelector(
  [employeeDirectoryImportsByIdSelector],
  (employeeDirectoryImportsById) => Object.values(employeeDirectoryImportsById),
);

export const employeeDirectoryImportForIdSelector = createSelector(
  [
    employeeDirectoryImportsByIdSelector,
    (_state: State, employeeDirectoryImportId: number) => employeeDirectoryImportId,
  ],
  (employeeDirectoryImportsById, employeeDirectoryImportId) =>
    employeeDirectoryImportsById[employeeDirectoryImportId],
);

export const employeeDirectoryImportForOrgIdSelector = createSelector(
  [employeeDirectoryImportsSelector, (_state: State, orgId: number) => orgId],
  (employeeDirectoryImports, orgId) => employeeDirectoryImports.filter((s) => s.orgId === orgId),
);

const employeeDirectoryImportsStateByOrgIdSelector = (state: State) =>
  state.employeeDirectoryImports.employeeDirectoryImportsStateByOrgId;
export const employeeDirectoryImportsStateForOrgIdSelector = createSelector(
  [employeeDirectoryImportsStateByOrgIdSelector, (_state: State, orgId: number) => orgId],
  (employeeDirectoryImportsStateByOrgId, orgId) => employeeDirectoryImportsStateByOrgId[orgId],
);
